module.exports = __webpack_public_path__ + "img/newproject2.39362e7b.jpg";